import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { withData } from '../utility/DataContext';
import CheckCircleRounded from '@material-ui/icons/CheckCircleRounded';
import CheckRounded from '@material-ui/icons/CheckRounded';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from './IconButton';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import CloudUpload from '@material-ui/icons/CloudUpload';
import Jimp from 'jimp';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom'


const styles = theme => ({
  submitter: {
    maxWidth: 350,
    width: '100%'
  },
  paper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  textDiv: {

  },
  field: {
    maxWidth: 200,
    transform: 'scale(1.4)',
    marginTop: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 4,
  },
  checkIcon: {
    fontSize: 20
  },
  footer: {
    display: 'flex',
    textAlign: 'right',
    marginTop: theme.spacing.unit * 2,
    justifyContent: 'space-between',
  },
  imgContainer: {
    width: '100%',
    textAlign: 'center',
    marginBottom: theme.spacing.unit * 3,
  },
  image: {
    borderRadius: 4
  },
  loading: {
    width: '100%',
  },
  dialog: {
    minWidth: 180,
    padding: theme.spacing.unit * 2,
    textAlign: 'center'
  },
  successIcon: {
    fontSize: 80
  },
  uploadMessage: {
    paddingTop: 10
  },
  backButton: {
    marginTop: 35
  },
  progress: {
    marginBottom: 15
  }
});


class Submitter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      invalidText: '',
      checking: false,
      buffer: null,
      imageLoaded: false,
      imageResized: false,
      uploadDialog: false,
      uploadCompleted: false,
      memeName: ''
    };
  }

  onInputChange = event => {
    const text = event.target.value;
    this.checkValidate(text);
  }

  componentDidMount() {
    const src = this.props.data.src;
    const len = this.props.data.resizeLength;
    Jimp.read(src).then(image => {
      const cr = this.props.data.cropArea;
      const w = image.bitmap.width;
      const h = image.bitmap.height;
      image
        .crop(cr.pos.x * w, cr.pos.y * h, cr.size.width * w, cr.size.height * h)
        .scaleToFit(len, len)
        .quality(80)
        .getBase64(Jimp.MIME_JPEG, (err, buffer) => {
          this.setState({
            buffer: buffer,
            imageResized: true
          });
        });
    });
  }

  checkValidate = text => {
    this.setState({checking: true});
    if (text === ''){
      this.setInvalid('名稱不能空白');
      return;
    }
    const re = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
    if (!re.test(text)){
      this.setInvalid('不能有特殊字元');
      return;
    }
    if (text.startsWith('夢想')){
      this.setInvalid('開頭不能有夢想');
      return;
    }
    const ref = this.props.data.firestore.collection('templates').doc(text);
    ref.get().then(snapshot => {
      if (snapshot.exists) {
        this.setInvalid('此名稱已被使用');
      }else{
        this.setState({
          validate: true,
          checking: false,
          memeName: text
        })
      }
    });
  }

  setInvalid = message => {
    this.setState({
      checking: false,
      validate: false,
      invalidText: message
    });
  }

  upload = () => {
    this.setState({
      uploadDialog: true
    });

    this.uploadImage();
  }

  uploadImage = () => {
    const publicHeader = 'https://storage.googleapis.com/ms-meme.appspot.com/';

    const filepath = ('templates/' + Date.now() + '.jpg').replace(',', '');
    const ref = this.props.data.storage.child(filepath);
    ref.putString(this.state.buffer, 'data_url').then(() => {
      const publicLink = publicHeader + filepath;
      this.updateDatabase(publicLink);
    });


  }

  updateDatabase = link => {
    const ref = this.props.data.firestore.collection('templates').doc(this.state.memeName);
    ref.set({
      count: 0,
      url: link,
      usedBy: [],
      date: this.props.data.now()
    }).then(() => {
      this.setState({uploadCompleted: true});
    });
  }

  render() {
    const {classes} = this.props;
    return (
      <div className={classes.submitter}>
        <div className={classes.imgContainer}>
          {!this.state.imageLoaded && 
              <CircularProgress color="primary" size={150} thickness={1.5} />
          }
          <img src={this.state.buffer} style={{display: this.state.imageResized && this.state.imageLoaded ? 'inline-block' : 'none'}}className={classes.image} onLoad={()=>this.setState({imageLoaded: true})} alt='resized' />
        </div>
        <Paper className={classes.paper}>
          <div className={classes.textDiv}>
            <TextField
              className={classes.field}
              label='貼圖名稱'
              helperText={this.state.validate ? '' : this.state.invalidText}
              FormHelperTextProps={{
                error: true,
                style: {
                  textAlign: 'right'
                }
              }}
              margin='normal'
              name='meme-name'
              InputLabelProps={{
                className: classes.input,
                disableAnimation: false
              }}
              InputProps={{
                className: classes.input,
                endAdornment: 
                  <InputAdornment position="end">
                    {this.state.checking && <CircularProgress color="primary" size={20} />}
                    {!this.state.checking && this.state.validate && <CheckRounded className={classes.checkIcon} color='primary'/>}
                    {!this.state.checking && !this.state.validate && this.state.invalidText !== '' && <ErrorOutlineRounded className={classes.checkIcon} color='error'/>}
                  </InputAdornment>
              }}
              onChange={this.onInputChange}
            />
          </div>
        </Paper>
        <div>
          <div className={classes.footer}>
            <IconButton icon={<NavigateBefore/>} text='上一步' className={classes.stepButton} onClick={()=>this.props.changeMode('crop')} isLeft />
            <IconButton icon={<CloudUpload/>} color='primary' text='上傳' className={classes.stepButton} disabled={!(this.state.validate && this.state.imageLoaded)} onClick={this.upload} />
          </div>
        </div>
        <Dialog open={this.state.uploadDialog}>
          <div className={classes.dialog}>
            <div style={{textAlign: 'center'}}>
              {this.state.uploadCompleted ?
                <CheckCircleRounded className={classes.successIcon} color='primary'/> :
                <CircularProgress className={classes.progress} color="primary" size={100} thickness={2.5} />
              }
            </div>
            <Typography variant="title" className={classes.uploadMessage}>
              {this.state.uploadCompleted ? '完成!' : '上傳中'}
            </Typography>
            {this.state.uploadCompleted &&
              <Button variant="outlined" className={classes.backButton} onClick={()=>this.props.history.push('/')}>
                返回
              </Button>
            }
          </div>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(withData(withStyles(styles)(Submitter)));


// WEBPACK FOOTER //
// ./src/components/Submitter.js